import { render, staticRenderFns } from "./NumberBox.vue?vue&type=template&id=4a00877a&scoped=true&"
import script from "./NumberBox.vue?vue&type=script&lang=js&"
export * from "./NumberBox.vue?vue&type=script&lang=js&"
import style0 from "./NumberBox.vue?vue&type=style&index=0&id=4a00877a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00877a",
  null
  
)

export default component.exports